// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackFormSubmitParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/form/trackFormSubmit";

const useTrackFormSubmit = (parameters: TrackFormSubmitParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.util.getEventTrackerHook(ga.track.formSubmit, parameters, options);
};

export default useTrackFormSubmit;
